<template>
  <div class="div_footer">
    版权所有：上海科探信息技术有限公司&nbsp;&nbsp;&nbsp;沪ICP备15011261号
  </div>
</template>

<script>
export default {
  name: "footer",
  data() {
    return {};
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.div_footer {
  height: 80px;
  line-height: 80px;
  text-align: center;
  background: #433c5a;
  color: #b8c6dc;
}
</style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/wechat/layout/Footer.vue